import { call } from 'redux-saga/effects';
import { makeRestartable } from 'utils/redux/saga';
import folders from './folders';
import uploads from './uploads';
import resources from './resources';

const rootSagas = [folders, uploads, resources].map(makeRestartable);

export default function* root() {
  yield rootSagas.map(saga => call(saga));
}



// WEBPACK FOOTER //
// ./src/modules/bucket/sagas/index.js